import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Account } from '@feathr/blackbox';
import { ImageThumbnailCell } from '@feathr/components';

export interface ILogoCellProps {
  original: Account;
}

// Matches --avatar-size-lg (48px), so the logo lines up with the avatars in the CSM column.
const LOGO_SIZE = 48;

/**
 * Account logo for the accounts table. The alt text is empty on purpose: the logo repeats the
 * account name shown in the adjacent column, so announcing it would just duplicate the row label.
 */
function LogoCell({ original }: Readonly<ILogoCellProps>): JSX.Element {
  return (
    <ImageThumbnailCell alt={''} height={LOGO_SIZE} src={original.get('logo')} width={LOGO_SIZE} />
  );
}

export default observer(LogoCell);
